import React, { useEffect, useState } from "react";
import Chart from 'chart.js';

const BarChart = (props) => {

  useEffect(() => {
    displayChart();	
  }, [props.data]);

  const displayChart = () => {
    const node = document.getElementById(props.id);
    let teamPerformanceChart = new Chart(node, {
      type: 'bar',
      data: props.data,
      options: {
        legend: {
          position: "bottom",
          align: "start",
          labels: {
            usePointStyle: true,
            fontSize: 15,
            padding: 30
          }
        },
        elements: {
          line: {
            tension: 0
          }
        },
      }
    });
    props.setTeamPerformanceChart(teamPerformanceChart);    
  }
  return (
    <div>
      <canvas
        id={props.id}
      />
    </div>
  )
}

export default BarChart;
